import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Chip from 'src/components/Chip'
import tracking from 'src/shared/tracking'
import { IconType } from 'src/componentsV2/CoreUX/primitives/Icon/Icon.types'
import { ExpressDisclaimer } from '../ExpressDisclaimer/ExpressDisclaimer'
import './OrderDelivery.scss'

interface Props {
  timeSlots: any[]
  selectedTimeSlot: any
  address: string
  handleFieldChange: (name, value) => void
  hasWine: boolean
  isExpressOrder?: boolean
}

export const OrderDelivery: FC<Props> = ({
  timeSlots,
  selectedTimeSlot,
  address,
  handleFieldChange,
  hasWine,
  isExpressOrder = false
}) => {
  const { t } = useTranslation()

  return (
    <div className="order_delivery">
      <div>
        <div className="order_delivery__header">
          <p className="order_delivery__header__title">
            {t('orderSummary.delivery_window')}
          </p>
          {hasWine && (
            <p className="order_delivery__header__wine-disclaimer">
              {t('orderSummary.delivery_wine_disclaimer')}
            </p>
          )}
        </div>
        <div className="order_timeslots_section">
          <div className="chips-container">
            {timeSlots.map(timeslot => (
              <Chip
                key={timeslot.label}
                selected={
                  selectedTimeSlot &&
                  timeslot.start === selectedTimeSlot.start &&
                  timeslot.end === selectedTimeSlot.end
                }
                className="chip"
                label={timeslot.label}
                onClick={() => {
                  handleFieldChange('selectedTimeslot', timeslot)
                  tracking.track('Change Delivery Time')
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="order_address_section">
        <div className="order_delivery__header">
          <p className="order_delivery__header__title">
            {t('orderSummary.delivery_address')}
          </p>
          {hasWine && (
            <p className="order_delivery__header__wine-disclaimer">
              {t('orderSummary.delivery_wine_disclaimer')}
            </p>
          )}
        </div>
        <span className="address">{address}</span>
      </div>

      {isExpressOrder && (
        <ExpressDisclaimer
          icon={IconType.Info}
          body={t('orderSummary.express_order_charge_disclaimer')}
        />
      )}
    </div>
  )
}
